import { request } from "../../utils/config"

export const GET_TRANSFORM = async (params) => {
  const response = await request({
    url: `TransferLogs`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_ALL_TRANSFORM = async (params) => {
  const response = await request({
    url: `TransferLogs`,
    params: { ...params, PageSize: 10000000 },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

// Kunlar bo'yicha guruhlangan perevodlar (har bir kun alohida qator)
export const GET_FILTERED_TRANSFERS = async (params) => {
  const response = await request({
    url: `TransferLogs/GetTransfersByFilter`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_ALL_FILTERED_TRANSFERS = async (params) => {
  const response = await request({
    url: `TransferLogs/GetTransfersByFilter`,
    params: { ...params, PageSize: 10000000 },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

// Boshliq (2026-09-03, 6-qaror): «Kam chiqdi» — perevodda jo'natilgandan KAM
// qabul qilingan qatorlar. Ma'lumot mainTransferLog da (TransferCount va
// AcceptedCount) allaqachon bor edi, faqat hech qayerda ko'rinmasdi.
export const GET_TRANSFER_SHORTAGES = async (params) => {
  const response = await request({
    url: `TransferLogs/Shortages`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
